export const defaultUserSettings = {};
export const makeName = (u) => `${u.firstName} ${u.lastName}`;
//# sourceMappingURL=users.js.map